import { combineReducers } from 'redux';

import { visibilityFiltersReducer } from './visibilityFiltersReducer';
import { activeViewsReducer } from './activeViewsReducer';
import { listingReducer } from './listingReducer';
import { contextualSupportReducer } from './contextualSupportReducer';
import { accessControlReducer } from './accessControlReducer';
import { uiDagReducer } from './uiDagReducer';
import { currentProjectReducer } from './currentProjectReducer';
import { sectionNavigationReducer } from './sectionNavigationReducer';

export const appReducer = combineReducers({
  visibilityFilters: visibilityFiltersReducer,
  activeViews: activeViewsReducer,
  listing: listingReducer,
  contextualSupport: contextualSupportReducer,
  accessControl: accessControlReducer,
  uiDag: uiDagReducer,
  currentProject: currentProjectReducer,
  sectionNavigation: sectionNavigationReducer,
});

export default appReducer;
